(function () {
    'use strict';

    angular
        .module('uwAgenda.settings.administration')
        .factory('Protocol', ProtocolFactoryFn);

    ProtocolFactoryFn.$inject = [];

    function ProtocolFactoryFn() {

        var Protocol = function () {

            // default values
            this.content = null;
            this.showAlwaysOnLoad = false;
            this.showInAgenda = false;
            this.showOnAppointmentSave = false;
            this.showOnAppointmentCut = false;
            this.showOnAppointmentCopy = false;
            this.showOnAppointmentDelete = false;
            this.showOnDayTaskAdd = false;
            this.showOnInboundCall = false;
            this.showOnOutboundCall = false;
            this.showOnTransferCall = false;
            this.showInSidebar = false;
            this.showOnAgendaChange = false;
            this.showOnNewPatientSelection = false;
            this.showOnNewPatientNotAllowed = false;
            this.showOnAppointmentView = false;
            this.fK_ProtocolCategory = null;
            this.fK_User = null;
            this.fK_AppointmentType = null;
            this.fontAwesomeIcon = null;
            this.protocolCategory = null;
            this.user = null;
            this.userDto = null;
            this.appointmentType = null;
            this.deleted = false;

            // extend object
            function extend(protocol) {
                var self = this;
                angular.extend(self, protocol);
            } // extend

            // prepare for backend save
            function prepareForSave() {
                var self = this;

                self.fK_User = self.userDto ? self.userDto.id : null;
                self.fK_ProtocolCategory = self.protocolCategory ? self.protocolCategory.id : null;
                self.fK_AppointmentType = self.appointmentType ? self.appointmentType.id : null;

                delete self.protocolCategory;
                delete self.user;
                delete self.userDto;
                delete self.appointmentType;
            } //prepare

            // make copy
            function createCopy() {
                var self = this;

                //copy values from existing protocol
                var copy = new Protocol();
                copy.extend(self);

                //reset automatic- and user-specific value
                copy.id = 0;
                copy.fK_User = null;
                copy.user = null;
                copy.userDto = null;
                copy.fK_AppointmentType = null;
                copy.appointmentType = null;
                copy.deleted = false;
                copy.timestamp = null;

                return copy;
            }

            //public
            this.extend = extend;
            this.prepareForSave = prepareForSave;
            this.createCopy = createCopy;

        };

        return Protocol;
    }
})();